export interface CacheStore {
	getItem<T>(key: string): T | null;
	setItem<T>(key: string, value: T): void;
	removeItem(key: string): void;
	clear(): void;
}

export class MemoryCache implements CacheStore {
	private store: Map<string, any> = new Map();
	getItem<T>(key: string): T | null {
		return this.store.get(key) || null;
	}
	setItem<T>(key: string, value: T) {
		this.store.set(key, value);
	}
	removeItem(key: string) {
		this.store.delete(key);
	}
	clear() {
		this.store.clear();
	}
}

export class Cache {
	constructor(private _store: CacheStore = new MemoryCache()) {}

	get store() {
		return this._store;
	}
	set store(newStore: CacheStore) {
		this._store = newStore;
	}
	get<T>(key: string): T | null {
		return this._store.getItem<T>(key);
	}
	set<T>(key: string, value: T) {
		return this._store.setItem<T>(key, value);
	}
	remove(key: string) {
		this._store.removeItem(key);
	}
	clear() {
		this._store.clear();
	}
	configure(store: CacheStore) {
		this._store = store;
	}
}

export const globalCache = new Cache();
